@if (hostWidth) {
  <!-- Three placeholder site rows, mirroring the loaded table body. -->
  <app-loading-skeleton
    class="shrink-0 w-full h-[212px] px-4"
    [viewBox]="'0 0 ' + hostWidth + ' 212'"
    backgroundTextClass="text-background-fixed"
  >
    <svg:rect x="0" y="0" rx="8" ry="8" [attr.width]="hostWidth - 32" height="68" />
    <svg:rect x="0" y="72" rx="8" ry="8" [attr.width]="hostWidth - 32" height="68" />
    <svg:rect x="0" y="144" rx="8" ry="8" [attr.width]="hostWidth - 32" height="68" />
  </app-loading-skeleton>
}
